import { ia, iaRa } from '../../../../../../../../lib/helpers/utility';

import { HPMacro, SOAPMacro } from './constants';

export const findNoteMacroType = (type) => {
  switch (type) {
    case 'hp':
      return HPMacro;
    case 'soap':
      return SOAPMacro;
    default:
      return [];
  }
};

export const createNoteMacroObject = ({
  name,
  type,
  noteType,
  advancedHP,
  advancedSOAP,
  advancedCustomNote,
  clinicalNote,
  overviewData,
  forms
}) => {
  const currentMacroFields = findNoteMacroType(noteType);

  const clinicalNoteObject = {};
  let advForms = {};

  for (const key of currentMacroFields) {
    clinicalNoteObject[key] = clinicalNote?.[key];
  }

  if (['hp', 'intake'].includes(noteType)) {
    advForms = {
      ...advForms,
      ...(ia(advancedHP) && { advancedHP })
    };
  }

  if (['soap', 'progress'].includes(noteType)) {
    advForms = {
      ...advForms,
      ...(ia(advancedSOAP) && { advancedSOAP })
    };
  }

  const customNoteTypes = Object.keys(advancedCustomNote || {});
  if (iaRa(customNoteTypes).includes(noteType)) {
    const advancedForms = advancedCustomNote?.[noteType];
    advForms = {
      ...advForms,
      ...(ia(advancedForms) && { advancedCustomNote: advancedForms }),
      customNoteType: noteType
    };
  }

  return {
    name,
    body: {
      clinicalNote: clinicalNoteObject,
      overviewData,
      ...advForms,
      forms
    },
    type
  };
};
